/**
 * Player-role colors & labels — single source of truth so every page
 * (Lineup Playground, Trade Machine, …) renders roles identically.
 */
export type RoleChipColor = 'primary' | 'secondary' | 'success' | 'default';

export const getRoleColor = (role: string): RoleChipColor => {
  switch ((role || '').toLowerCase()) {
    case 'top_order':
      return 'primary';
    case 'all_rounder':
    case 'middle_lower_order':
    case 'pace_ar':
    case 'spin_ar':
      return 'secondary';
    case 'bowler':
    case 'pacer':
    case 'spinner':
      return 'success';
    default:
      return 'default';
  }
};

export const getRoleLabel = (role: string): string => {
  switch ((role || '').toLowerCase()) {
    case 'top_order':
      return 'Top Order';
    case 'all_rounder':
      return 'All Rounder';
    case 'middle_lower_order':
      return 'Middle/Lower';
    case 'bowler':
      return 'Bowler';
    // v_player_roles vocabulary (bowling-type aware)
    case 'pacer':
      return 'Pacer';
    case 'spinner':
      return 'Spinner';
    case 'pace_ar':
      return 'Pace AR';
    case 'spin_ar':
      return 'Spin AR';
    default:
      // Title-case every underscore-separated word; cricket acronyms stay caps
      // (covers v_player_roles values like post_pp, pp_specialist, pace_ar).
      return (role || '')
        .split('_')
        .filter(Boolean)
        .map((w) =>
          ['ar', 'pp', 'mo', 'so', 'wk'].includes(w.toLowerCase())
            ? w.toUpperCase()
            : w.charAt(0).toUpperCase() + w.slice(1)
        )
        .join(' ');
  }
};
